import { useState, useEffect } from 'react';
import { getRandomAd } from '../services/api';

export default function AdBanner() {
  const [ad, setAd] = useState(undefined); // undefined = loading, null = no ads

  useEffect(() => {
    getRandomAd()
      .then(setAd)
      .catch(() => setAd(null));
  }, []);

  if (!ad) return null;

  return (
    <a
      className="ad-banner"
      href={ad.linkUrl}
      target="_blank"
      rel="noopener noreferrer sponsored"
      aria-label={`Advertisement: ${ad.businessName}`}
    >
      <span className="ad-label">AD</span>

      {ad.imageUrl && (
        <img className="ad-image" src={ad.imageUrl} alt={ad.businessName} loading="lazy" />
      )}

      <div className="ad-text">
        <span className="ad-business">{ad.businessName}</span>
        <span className="ad-tagline">{ad.tagline}</span>
      </div>

      <span className="ad-cta">Visit →</span>
    </a>
  );
}
